<!-- BARRA AZUL SUPERIOR - País, Usuario, Idioma, Descarga -->
<div class="container-fluid headboard-top">
  <div class="row align-items-center">
    <!-- País -->
    <div class="col-auto">
      <div class="country-info-display">
        <i class="bi bi-geo-alt-fill"></i>
        <span class="country-text">{{ countryName }}</span>
      </div>
    </div>

    <!-- Spacer para empujar opciones a la derecha -->
    <div class="col"></div>

    <!-- Opciones de usuario, idioma y descarga -->
    <div class="col-auto">
      <div class="top-nav-options">
        <!-- Usuario -->
        <ng-container *ngIf="isLoggedUser(); else elseTemplate">
          <div class="dropdown top-nav-item">
            <a class="nav-link dropdown-toggle" role="button" id="userAccountMenuDropdown"
              data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-person-fill"></i>
              <span>{{accountName}}</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userAccountMenuDropdown">
              <li><a class="dropdown-item" (click)="myAccount()">{{'menu.my_account' | translate}}</a></li>
              <li><a class="dropdown-item" (click)="logout()">{{'menu.logout' | translate}}</a></li>
            </ul>
          </div>
        </ng-container>
        <ng-template #elseTemplate>
          <div class="top-nav-item">
            <a [routerLink]="['/login']" class="nav-link">
              <i class="bi bi-person-fill"></i>
              <span>{{'store.enter' | translate}}</span>
            </a>
          </div>
        </ng-template>
        
        <!-- Idioma -->
        <div class="dropdown top-nav-item">
          <a class="nav-link dropdown-toggle" role="button" id="languageMenuDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fa fa-globe"></i>
            <span>{{ siteLanguage }}</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="languageMenuDropdown">
            <li *ngFor="let language of languageList">
              <a class="dropdown-item" (click)="changeSiteLanguage(language.code)">
                {{ language.label }}
              </a>
            </li>
          </ul>
        </div>
        
        <!-- Descarga -->
        <div class="top-nav-item">
          <a class="nav-link" [href]="desktopApplicationDownloadLink" download>
            <i class="bi bi-download"></i>
            <span>{{'store.download_i3bookapp' | translate}}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- BARRA BLANCA INFERIOR - Logo, Búsqueda, Menú Principal -->
<div class="container-fluid headboard-bottom">
  <div class="row align-items-center">
    <!-- Logo -->
    <div class="col-auto">
      <a [routerLink]="['/book/shop']" routerLinkActive="router-link-active" class="navbar-brand">
        <ng-container *ngIf="countryName !== 'Colombia' && countryName !== ''">
          <img src="../../../../assets/img/png/gridmark.png" class="imgLogo gridmark" alt="Logo">
        </ng-container>
        <ng-container *ngIf="countryName === 'Colombia'">
          <img src="../../../../assets/img/png/logo-new.png" class="imgLogo i3book" alt="Logo">
        </ng-container>
      </a>
    </div>

    <!-- Búsqueda -->
    <div class="col" *ngIf="showSearchBar">
      <div class="search-container">
        <i class="bi bi-search"></i>
        <input type="text" class="form-control search-input" [(ngModel)]="searchTerm" (keyup.enter)="searchLikeString()"
          placeholder="{{'store.search_book' | translate}}" aria-label="Search" #searchInput>
        <button class="btn btn-search" *ngIf="searchTerm.length > 0" (click)="onCancelSearch()">
          {{'store.delete' | translate}}
        </button>
        <button class="btn btn-search" *ngIf="searchTerm.length <= 0">
          {{'store.search' | translate}}
        </button>
      </div>
    </div>

    <!-- Menú principal -->
    <div class="col-auto d-none d-lg-block" style="margin-left: auto;">
      <div class="main-menu-container">
        <ul class="nav main-nav">
          <li class="nav-item" *ngFor="let menuItem of menuData let i = index">
            <ng-container *ngIf="i < limitItemsMenu">
              <ng-container *ngIf="menuItem.children === undefined || menuItem.children.length == 0; else itemHasChildren">
                <a [routerLink]="[menuItem.url]" routerLinkActive="router-link-active" class="nav-link main-menu-item">
                  <i class="{{menuItem.icon}}"></i>
                  <span>{{menuItem.titleKey | translate}}</span>
                </a>
              </ng-container>
              <ng-template #itemHasChildren>
                <a class="nav-link main-menu-item dropdown-toggle" id="menuDropDown{{i}}" role="button" 
                   data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="{{menuItem.icon}}"></i>
                  <span>{{menuItem.titleKey | translate}}</span>
                </a>
                <ul class="dropdown-menu" attr.aria-labelledby="menuDropDown{{i}}">
                  <li *ngFor="let child of menuItem.children">
                    <a class="dropdown-item" [routerLink]="[child.url]" routerLinkActive="router-link-active">
                      <i class="{{child.icon}}"></i>
                      <span class="menu-item-text">{{ getMenuItemText(child) }}</span>
                    </a>
                  </li>
                </ul>
              </ng-template>
            </ng-container>
          </li>
        </ul>
      </div>
    </div>

    <!-- Botón menú móvil -->
    <div class="col-auto d-lg-none">
      <button class="btn btn-mobile-menu" type="button" data-bs-toggle="collapse" data-bs-target="#mainCollapse"
        aria-expanded="false" aria-controls="mainCollapse">
        <i class="bi bi-list"></i>
      </button>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="collapse" id="mainCollapse">
      <hr class="line">
      <div class="row responsive-main-menu">
        <div class="col-12" *ngFor="let menuItem of menuData let i = index">
          <ul class="nav justify-content-start">
            <li class="responsive-nav-item">
              <ng-container
                *ngIf="menuItem.children === undefined || menuItem.children.length == 0; else itemHasChildren">
                <a [routerLink]="[menuItem.url]" routerLinkActive="router-link-active"
                  routerLinkActive="router-link-active" class="mainMenuItem"><i
                    class="{{menuItem.icon}}"></i>&nbsp;{{menuItem.titleKey}}<i class="bi bi-caret-down-fill"></i></a>
              </ng-container>
              <ng-template #itemHasChildren>
                <a class="mainMenuItem" data-bs-toggle="collapse" href="#collapseSubMenu{{i}}" role="button"
                  aria-expanded="false" aria-controls="collapseExample">
                  <i class="{{menuItem.icon}}"></i>&nbsp;{{menuItem.titleKey | translate}}&nbsp;<i
                    class="bi bi-caret-down-fill"></i>
                </a>
                <div class="collapse" id="collapseSubMenu{{i}}">
                  <ul class="sub-menu">
                    <li *ngFor="let child of menuItem.children">
                      <a class="mainMenuItemBase dropdown-item" [routerLink]="[child.url]"
                        routerLinkActive="router-link-active">
                        <i class="{{child.icon}}"></i>&nbsp;{{child.titleKey | translate}}
                      </a>
                    </li>
                  </ul>
                </div>
              </ng-template>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<hr class="line w-100" style="margin-top: 0 !important;">